<template>
    <div class="classify-container">
        <el-row>
            <el-col :md="!isMember ? 24: 20">
                <div class="classify_group" v-for="groupClassify in groupClassifies" v-if="groupClassifies.length > 0">
                    <title-bar :name="groupClassify.groupName">
                        <i class="el-icon-price-tag" slot="titleName"></i>
                    </title-bar>
                    <div class="classify_row">
                        <div class="classify-card" v-for="(item, index) in groupClassify.classifies" :key="index" @click="toNextLevel(item.id)">
                            <img :src="createFilePath(item.fileName)" v-if="item.fileId">
                            <div class="card-title">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :md="4" v-if="isMember">
                <classify-right-menu :active="active" :searchQuery="searchQuery" @changeInput="changeInput" @clickItem="clickItem" />
            </el-col>
        </el-row>
        <el-empty :image-size="200" v-if="groupClassifies.length === 0"></el-empty>
    </div>
</template>
<script>
import TitleBar from '../../components/TitleBar.vue'
import ClassifyRightMenu from './classifyRightMenu.vue';

export default {
    props: ['classifyId', 'type'],
    data() {
        return {
            groupClassifies: [],
            paramName: '',
            searchQuery: undefined,
            active: '1',
            isMember: false,
        }
    },
    created() {
        if (this.classifyId) {
            this.toNextLevel(this.classifyId)
        } else {
            this.getClassifyInfos()
        }
        if (this.hasToken) {
            this.exitMember()
        }
    },
    computed: {
        hasToken() {
            return localStorage.getItem("token") !== null;
        }
    },
    methods: {
        exitMember() {
            this.$api.get('/emcMember/exit').then(res => {
                this.isMember = res.data
            })
        },
        getClassifyInfos() {
            let queryForm = {'type': this.type}
            if (this.searchQuery && this.searchQuery !== '') {
                queryForm.name = this.searchQuery
            }
            this.$api.get('/classifyInfo/listByParentId', queryForm).then(res => {
                this.groupClassifies = res.data
            })
        },
        createFilePath(fileName) {
            return `${this.domain}${fileName}`
        },
        toNextLevel(id) {
            const path = this.type === 'ANALYSIS' ? '/analysisShowList' : this.type === 'STANDARD' ? '/standardShowList' : '/deviceShowList'            
            this.$router.push({path: path, query: {classifyId: id, 'isMember': this.isMember}});
        },
        changeInput(val) {
            this.searchQuery = val;
            this.getClassifyInfos()
        },
        clickItem(active) {
            if (this.active !== active) {
                this.type = active === '1' ? undefined : active === '2' ? 'ANALYSIS' : 'STANDARD'
                this.active = active
                this.getClassifyInfos();
            }
        }
    },
    watch: {
        'type': {
            handler(value) {
                this.active = value === 'ANALYSIS' ? '2' : value === 'STANDARD' ? '3' : '1'
            },
            immediate: true,
            deep: true
        },
    },
    components: {TitleBar, ClassifyRightMenu}
}
</script>
<style lang="scss"  scoped>
.classify-container {
    padding: 10px 50px 20px 150px;
    min-height: 100%;
    background-image: linear-gradient(rgba(50, 0, 0, 0.05) 1px, transparent 0),linear-gradient(90deg, rgba(50, 0, 0, 0.05) 1px, transparent 0);
    background-size: 15px 15px;
    background-color: #efefef;

    img {
        width: 100%;
        height: 125px;
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 5px;
    }

    .card-title {
        width: 100%;
        text-align: center;
        font-size: 20px;
        margin-bottom: -12px;
    }

    .classify_group {
        margin-top: 30px;

    }

    .classify_row{
        display: flex;
        flex-wrap: wrap;
    }

    .classify-card{
        border-radius: 5px;
        border: #a3bacc solid 1px;
        background-color: white;
        margin-right: 30px;
        margin-top: 30px;
        width: 250px;
        height: 160px;
        cursor: pointer;
        transform:translateY(0px);
        -webkit-transform:translateY(0px);
        -moz-transform:translateY(0px);
        -webkit-transition:all 0.3s ease;
        -moz-transition:all 0.3s ease;
        -o-transition:all 0.3s ease;
        transition:all 0.3s ease
    }

    .classify-card:hover{
        transform:translateY(-6px);
        -webkit-transform:translateY(-6px);
        -moz-transform:translateY(-6px);
        box-shadow:0 26px 40px -24px rgba(0,36,100,.3);
        -webkit-box-shadow:0 26px 40px -24px rgba(0,36,100,.3);
        -moz-box-shadow:0 26px 40px -24px rgba(0,36,100,.3)
    }
}
</style>



// WEBPACK FOOTER //
// src/views/classify/classifyShowList.vue